import { NewFeatureHighlightGlobal } from "src/components/ui-components/NewFeature/NewFeatureHighlightGlobal";
import img from "./assets/coverImage.png";
import { AnchorButton } from "src/components/ui-components/Button/AnchorButton";
import { useSession } from "src/components/session/session";

export const ChristmasAnnouncement = () => {
  const session = useSession();

  if (!session) {
    return null;
  }

  return (
    <NewFeatureHighlightGlobal
      title="Unwrap New Features with Dune"
      description="Celebrate with us! Explore new alerts, cost-effective datapoints, CRUD query endpoints in Plus, quick Command+K access, sleek dark mode, and easy chart screenshots. Upgrade your analytics experience this festive season and hit the ground running in 2024!"
      imgSrc={img.src}
      endDate={new Date("2024-01-01")}
      actions={
        <AnchorButton
          size="M"
          theme="primary"
          href="https://community.dune.com/blog/unwrap-our-latest-features"
          target="_blank"
        >
          Learn more
        </AnchorButton>
      }
      feature="christmas-announcement-2023"
    />
  );
};
